export const showComma = (totalLength: number, currentIndex: number) => {
  return totalLength - 1 !== currentIndex;
};
